import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import { updateCategorie } from '../../../container/actions/categorie-action';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';

class DevisParams extends Component {

    constructor(props) {
        super(props);
        this.state = {
            categorie: this.props.params.categorie,
            ETAG: this.props.params.ETAG,
            DEPE: this.props.params.DEPE,
            CAVE: this.props.params.CAVE,
            COMB: this.props.params.COMB,
        };
        //this.editCategorie = this.editCategorie.bind(this);
    }

    handleChange = event => {
        this.props.params[event.target.name] = event.target.value;
        this.setState({ [event.target.name]: event.target.value });
    };

    checkBoxHandleChange = event => {
        this.props.params[event.target.name] = event.target.checked;
        this.setState({ [event.target.name]: event.target.checked });
    };

    editCategorie = (event) => {
        this.props.params[event.target.name] = event.target.value;
        //this.props.editCategorie(event.target.value);
        //console.log(this.props);
        this.props.updateCategorie(event.target.value);
        this.setState({ [event.target.name]: event.target.value });
    }

    renderCategories() {
        const { classes } = this.props;

        var catList = [];
        this.props.categories.forEach(cat => {
            catList.push(<MenuItem key={cat.ID} value={cat.ID}>{cat.label}</MenuItem>);
        });
        
        return (
            <FormControl className={`${classes.formControl} devisContentCatList`}>
                <InputLabel htmlFor="devisContentParamsCategories">Cat&eacute;gorie de devis</InputLabel>
                <Select
                    value={this.state.categorie}
                    onChange={this.editCategorie}
                    inputProps={{
                        name: 'categorie',
                        id: 'devisContentParamsCategories'
                    }}>
                    <MenuItem value="">
                        <em>aucune</em>
                    </MenuItem>
                    {catList}
                </Select>
            </FormControl>
        );
    }

    render() {
        return (
            <div id="devisContentParams">
                <div className="editDiv">
                    <h5>Type de devis</h5>
                    {this.renderCategories()}
                </div>
                <div className="editDiv">
                    <h5>Informations sur le bâtiment</h5>
                    <div className="inlineInput">
                        <div>
                            <InputLabel htmlFor="devisContentParamsCave">Cave</InputLabel>
                            <Checkbox defaultChecked color="default"
                                onChange={this.checkBoxHandleChange}
                                checked={this.state.CAVE}
                                inputProps={{
                                    name: 'CAVE',
                                    id: 'devisContentParamsCave'
                                }}
                            />
                        </div>
                        <div>
                            <InputLabel htmlFor="devisContentParamsCombles">Combles</InputLabel>
                            <Checkbox defaultChecked color="default"
                                onChange={this.checkBoxHandleChange}
                                checked={this.state.COMB}
                                inputProps={{
                                    name: 'COMB',
                                    id: 'devisContentParamsCombles'
                                }} />
                        </div>
                    </div>
                    <div className="inlineInput">
                        <TextField type="number"
                            label="Nombre d'étages"
                            onChange={this.handleChange}
                            value={this.state.ETAG}
                            className="numberTextField"
                            inputProps={{
                                name: 'ETAG',
                                id: 'devisContentParamsEtages',
                                min: "0",
                                max: "10",
                                step: "1"
                            }} />
                        <TextField type="number"
                            label="Dépendances"
                            onChange={this.handleChange}
                            value={this.state.DEPE}
                            className="numberTextField"
                            inputProps={{
                                name: 'DEPE',
                                id: 'devisContentParamsDependances',
                                min: "0",
                                max: "10",
                                step: "1"
                            }} />
                    </div>
                </div>
            </div>
        );
    }
}

DevisParams.propTypes = {
    params: PropTypes.object.isRequired,
    categories: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = props => ({
    categorie: props.categorie
});

const mapActionsToProps = dispatch => {
    return bindActionCreators({
        //editCategorie: updateCategorie
        updateCategorie
    }, dispatch)
    /*{
        dispatch: (updateCategorie) => { dispatch(updateCategorie) }
    }*/
};

export default connect(mapStateToProps, mapActionsToProps)(DevisParams);


// WEBPACK FOOTER //
// ./src/components/content/devis/DevisParams.js